import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Center, Loader } from "@mantine/core";
import { useAuth } from "@/auth";

/** Gate for everything under /app: signed in AND email verified. Unauthenticated
 *  visitors go to login and come back to where they were via ?redirect=. */
export default function ProtectedRoute() {
  const { loading, isAuthenticated, emailVerified } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Center h="100vh">
        <Loader />
      </Center>
    );
  }
  if (!isAuthenticated) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/auth/login?redirect=${redirect}`} replace />;
  }
  if (!emailVerified) return <Navigate to="/auth/verify-email" replace />;
  return <Outlet />;
}
